import sensors from '@/js_sdk/Sensorsdata-UniPlugin-JS/Sensorsdata-UniPlugin-JS/index';
import store from '@/vuex/index';
import config from '@/config/index';
import { reportMiniProgramAdClick } from '@/api/common';




// * 神策事件白名单，只有在白名单内的事件，才会上报到神策
const sensorsEventWhiteList = [
  'GoodsDetail',
  'CreditGoodsDetail',
  'LOGIN',
  'SEARCH',
  'SubscribeMsg',
  'PromoterEvent',
  'UnloginAddCart',
  'InviterShare',
  'InviteeClick',
  'WXSTORE_CLICK_GOODS',
];

/**
 * 处理微信广告参数 gdt_vid
 */
function handleWxAdParams(options) {







}
function getReferer() {
  const pages = getCurrentPages() || [];
  if (pages.length > 0) {
    // 有上一级页面
    const lastPage = pages[pages.length - 2];
    return lastPage && lastPage.route;
  }
}

function setCache(key, gdtvid, weixinadinfo, expire = 0) {
  if (!key) {
    throw new Error('必须设置缓存的key!');
  }
  if (!gdtvid && gdtvid !== 0) {
    throw new Error('必须设置缓存的值!');
  }
  const pages = getCurrentPages();
  const page = pages.length > 0 ? pages[pages.length - 1] : {};
  const route = page.route || '';
  const now = Date.now();
  uni.setStorageSync(key, {
    expire: expire <= 0 ? 0 : now + expire * 1000,
    gdtvid,
    route,
    weixinadinfo,
  });
}

const eventReporter = {
  _state: {},
  _utm: {},
  getNetworkType() {
    return new Promise((resolve, reject) => {
      uni.getNetworkType({
        success: res => {
          resolve(res.networkType);
        },
        fail: err => {
          reject(err);
        },
      });
    });
  },
  setState(systemInfo, networkType) {},
  setPara(para = {}) {
    console.log(para);
  },
  setSensorsPara() {
    // 初始化参数配置
    sensors.setPara({
      server_url: config.IS_PROD
        ? 'https://sensorsdata.syounggroup.com/sa?project=soyoung'
        : 'https://sensorsdata.syounggroup.com/sa?project=soyoungtest',
      autoTrack: {
        // mpClick: false, // 事件:小程序元素点击
        // pageLeave: false, // 事件:小程序页面离开
        // appShow: false, // 事件:小程序显示
        mpClick: false, // 禁用点击事件
        pageLeave: false, // 禁用页面离开事件
        appShow: false, // 禁用小程序显示事件

        appLaunch: false, // 禁用小程序启动事件
        appHide: false, // 禁用小程序隐藏事件

      },
      show_log: true,

      is_track_single_page: false,
      heatmap: {
        clickmap: 'not_collect',
        scroll_notice_map: 'not_collect',
      },

      // 保留预置属性
      presetProperties: {
        mp: true, // 启用小程序预置属性
        h5: true, // 启用H5预置属性
      },
    });
  },
  save() {
    store.commit('$uStore', {
      name: 'reporterInfo',
      value: this._state,
    });
  },
  saveUtm() {
    store.commit('$uStore', {
      name: 'utm',
      value: this._utm,
    });
  },
  init() {
    // 确保禁用所有自动采集事件
    sensors.init();
  },
  // 获取到openId之后，将 anonId 和 openId 设置进去
  setOpenId(openId) {
    console.log('sensorssensorssensors');
    console.log(sensors);
    if (!openId) return;



  },
  // 登录成功之后调用，设置userId
  // 这里的userId就是新零售的memberId
  login(userId) {
    sensors.login(userId);
  },
  // 登出
  logout() {

    sensors.logout();

    delete this._state.userId;
    this.save();
  },
  /**
   * 注册通用属性，注册之后，所有的埋点事件上报都会带上通用的属性
   * @param {{
   * clientType: 'ios'|'android'|'wap'|'mini_apps'|'tt_mini_apps',
   * miniAppsId: String,
   * shopId: String
   * }} props 通用属性
   */
  registerApp(props) {
    // 设置事件公共属性
    sensors.register(props);
  },
  //* 获取神策埋点的distinct_id
  getSensorsDistinctId() {
    return sensors.getDistinctID();
  },
  async track(event, properties) {
    if (sensorsEventWhiteList.includes(event)) {
      sensors.track(event, properties);
    }
  },
  trackPromoterEvent(reportData = {}) {
    const postData = { ...reportData };
    console.log('trackPromoterEvent', JSON.stringify(postData));
    // this.track('PromoterEvent', postData);
  },
  // 点击邀请有礼邀请好友按钮事件
  trackInviterShare(reportData) {
    this.track('InviterShare', { ...reportData });
  },
  // 邀请有礼全部领取按钮事件
  trackInviteeClick(reportData) {
    this.track('InviteeClick', { ...reportData });
  },
  trackGoodsDetail(reportData = {}) {
    const referer = getReferer();
    let source = '99';
    switch (referer) {
      case 'pages/index':
        source = '1';
        break;
      case 'pages/category':
        source = '2';
        break;
      case 'pages/cart':
        source = '3';
        break;
      case 'pages/order/detail':
        source = '4';
        break;
      case 'pages/member-home':
        source = '5';
        break;
      case 'pages/search/search-index':
        source = '6';
        break;
      // 客服 预留
      // case 'pages/cart':
      //   source = '7';
      //   break;
      case 'pages/member/gift-records/index':
        source = '8';
        break;
      case 'pages/mini-index':
        source = '10';
        break;
      default:
        source = '99';
        break;
    }
    if (!referer) {
      source = '9';
    }
    reportData.source = source;
    this.track('GoodsDetail', { ...reportData });
  },
  trackAddCart(goods) {
    this.track('UnloginAddCart', {
      productId: goods.commodityId,
      productName: goods.name,
      productSku: goods.skuId,
      barCode: goods.barCode,
      price: goods.price,
      productNum: goods.quantity,
    });
  },
  // 点击微信小店商品
  trackClickWXStoreGoods(reportData = {}) {
    this.track('WXSTORE_CLICK_GOODS', { ...reportData });
  },
  trackCreditGoodsDetail(reportData = {}) {
    this.track('CreditGoodsDetail', { ...reportData });
  },
  // 新增的订阅小程序消息上报到神策
  trackSubscribeMsg(reportData = {}) {
    this.track('SubscribeMsg', reportData);
  },
  trackSkinRecognition(reportData = {}) {
    const { result, duration, size } = reportData;
    if (!result || !duration || !size) return;
    console.log('[事件上报: SkinRecognition]', reportData);
    this.track('SkinRecognition', { ...reportData });
  },
  trackSubscribeMessage(reportData) {
    this.track('SubscribeMessage', { ...reportData });
  },


























  insertCustomProperties(obj) {
    // 给事件添加自定义属性
    console.log('insertCustomProperties-val', obj);
    // const propsKeyArr = ['activity_classify_id'];
    console.log(sensors);
    sensors.instance.registerPropertyPlugin({
      isMatchedWithFilter: function(data) {
        return data.event === '$MPViewScreen' || data.event === '$pageview';
      },
      properties: function(data) {
        data.properties.activity_id = obj.activity_id;
        data.properties.promoterId = obj.promoterId;
      },
    });
  },
};

function proxy(options, lifetimesName, handler) {
  let autoTrack = true;
  if (options.trackOptions) {
    autoTrack = options.trackOptions.autoTrack;
  }
  if (!autoTrack) return;
  if (options[lifetimesName]) {
    // 如果配置中写了生命周期，先将传入的配置项中的生命周期函数取出来
    const lifetimesHandler = options[lifetimesName];
    // 然后将原始的生命周期函数，和我们需要操作的handler组成一个新的函数，重新赋值给该生命周期
    options[lifetimesName] = function() {
      handler.apply(this, arguments);
      lifetimesHandler.apply(this, arguments);
    };
  } else {
    // 如果配置中没写生命周期，就把我们需要操作的handler当做这个生命周期函数
    options[lifetimesName] = function() {
      handler.apply(this, arguments);
    };
  }
}

function appLaunch(options) {
  handleWxAdParams(options.query || {});
}

function appShow(options) {}

function appHide() {}

function pageOnLoad(options) {
  console.log('page on load');
  console.log(options);
  handleWxAdParams(options);
}

function pageOnHide() {
  // Page Hide 打点，发送 Health 数据。
  // Monitor.pageHide();
}

function pageOnUnload() {
  // Page Hide 打点，发送 Health 数据。
  // Monitor.pageHide();
}

function pageOnshare(options) {
  const onShareAppMessage = options.onShareAppMessage;
  options.onShareAppMessage = function() {
    // const reportData = { path: getCurrentPath(), query: this.mp_url_query };
    // eventReporter.track('MPShare', reportData);
    return onShareAppMessage.apply(this, arguments);
  };
}
























































export default eventReporter;
